import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

var _templateObject;

var _excluded = ["active"];
import PropTypes from 'prop-types';
import React from 'react';
import { system } from 'styled-system';
import { styledUnpoly } from '../helpers/styled';
var DimmerBase = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var active = _ref.active,
      props = _objectWithoutProperties(_ref, _excluded);

  return active ? /*#__PURE__*/React.createElement("div", Object.assign({}, props, {
    ref: ref
  })) : null;
});
DimmerBase.displayName = 'Dimmer';

var background = function background(opacity) {
  return "rgba(46, 53, 56, ".concat(opacity || '0.9', ")");
};

var dimmerStyles = system({
  position: true,
  opacity: {
    properties: ['backgroundColor'],
    transform: background
  }
});
export var Dimmer = styledUnpoly(DimmerBase).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'position' && prop !== 'opacity';
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  display: flex;\n  background-color: ", ";\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 100;\n  ", "\n"])), background(), dimmerStyles);
Dimmer.propTypes = {
  active: PropTypes.bool.isRequired
};
export default Dimmer;